/******************************************************************************
 * Copyright (c) 2026 Contributors to the Eclipse Foundation.
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * https://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *****************************************************************************/

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { ErrorHelpProps } from 'openvsx-webui';

const PROFILE_URL = 'https://accounts.eclipse.org/user/edit';

const ProfileLink = () => (
  <Link href={PROFILE_URL} target='_blank' rel='noopener noreferrer' underline='always'>
    your Eclipse account
  </Link>
);

// Help for the errors of the Eclipse login, which the server reports with these codes.
const ErrorHelp = ({ errorCode }: ErrorHelpProps) => {
  switch (errorCode) {
    case 'eclipse-missing-github-id':
      return (
        <Box sx={{ mt: 2 }}>
          Please fill in the &ldquo;GitHub Username&rdquo; field in <ProfileLink /> and try again.
        </Box>
      );
    case 'eclipse-mismatch-github-id':
      return (
        <Box sx={{ mt: 2 }}>
          Please edit the &ldquo;GitHub Username&rdquo; field in <ProfileLink /> or log in with a different GitHub
          account.
        </Box>
      );
    default:
      return null;
  }
};

export default ErrorHelp;
